import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
    Aangifte, AangifteRapport, BokkzAlgDataService,
    Box3InkomenUitSparenEnBeleggen, IncomeTaxEntity,
    OverigeBezitting, OverigeBezittingSoort
} from '@snelstart-ventures/fiscaal/domain-logic';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiIconModule } from '@snelstart/ui-icon';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box3-overige-bezittingen',
  templateUrl: './box3-overige-bezittingen.component.html',
  styleUrls: ['./box3-overige-bezittingen.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDetailsModule,
        CommonModule,
        SharedUiDialogModule,
        SharedUiIconModule
    ]
})
export class Box3OverigeBezittingenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;
    public overigeBezittingen = {} as FormGroup
    public labelJaar = '';
    public labelJaarEind = '';
    public jaar = 2024;
    public dialogVisible = false;
    public index = 0;

    specOWRFormGroup = this.fb.group<AangifteRapport>({});
    heeftOWR: boolean[] = [];

    public bezitSoort: SelectFormControlItem<string>[] = [
        {value: OverigeBezittingSoort.VORDERING, label: "Vordering"},
        {value: OverigeBezittingSoort.CONTANT_GELD, label: "Contant geld"},
        {value: OverigeBezittingSoort.CRYPTO, label: "Cryptobezittingen"},
        {value: OverigeBezittingSoort.BOUWDEPOT, label: "Bouwdepot"},
        {value: OverigeBezittingSoort.PREMIEDEPOT, label: "Premiedepot lijfr.-/kap.verzekering"},
        {value: OverigeBezittingSoort.PERIODIEKE_UITKERING, label: "Recht op periodieke uitkeringen"},
        // {value: OverigeBezittingSoort.SANCTIEWAARDE_NETTO_PENSIOEN, label: "Netto pensioen"},
        {value: OverigeBezittingSoort.KAPITAALVERZEKERING, label: "Niet-vrijgestelde kapitaalverzekering"},
        {value: OverigeBezittingSoort.OVERIG, label: "Overig"}
    ];

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }


    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router,
                private fb: FormBuilder) {
        this.overigeBezittingen = this.fb.group({
            box3OverigeBezittingen:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        })
    }

    get box3OverigeBezittingen(): FormArray {
        return this.overigeBezittingen.get('box3OverigeBezittingen') as FormArray;
    }

    addRijOverigeBezitting(): void {
        this.box3OverigeBezittingen.push(this.createOverigeBezittingenFormGroup()
        )
    }

    verwijderRijOverigeBezittingen(index: number): void {
        this.box3OverigeBezittingen.removeAt(index);
        this.overigeBezittingen.updateValueAndValidity()
        this.overigeBezittingen.markAsDirty()
        this.saveForm()
    }

    createOverigeBezittingenFormGroup(overig?: OverigeBezitting): FormGroup {
        return this.fb.group(({
            omschrijving: overig ? overig.omschrijving : undefined,
            bedrag: overig ? overig.bedrag : undefined,
            soort: overig ? overig.soort : undefined,
            nummer: overig ? overig.nummer : undefined,
            directRendement:  overig ? overig.directRendement : undefined,
            toenames:  overig ? overig.toenames : undefined,
            afnames:  overig ? overig.afnames : undefined,
            waardeEindJaar:  overig ? overig.waardeEindJaar : undefined
        } as OverigeBezitting))
    }

    public ngOnInit(): void {
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm()
                this.updateHeeftOWR();
                this.jaar = this.incomeTaxEntity.aangifte?.aangifteJaar!;
                this.labelJaar = this.incomeTaxEntity.aangifte?.aangifteJaar ? `Waarde 1-1-${this.incomeTaxEntity.aangifte?.aangifteJaar}` : 'Waarde 1-1';
            }
            if (incomeTaxEntity.year !== undefined) {
                this.jaar = incomeTaxEntity.year;
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.overigeBezittingen.dirty
  }


  private updateForm(): void {
        const overigeBezittingenLijst = this.incomeTaxEntity?.aangifte?.box3?.overigeBezittingen || [];
        const formArray = this.overigeBezittingen.get('box3OverigeBezittingen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > overigeBezittingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < overigeBezittingenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(overigeBezittingenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createOverigeBezittingenFormGroup(overigeBezittingenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity?.aangifte,
                box3: {
                    ...this.incomeTaxEntity?.aangifte?.box3,
                    overigeBezittingen: this.overigeBezittingen.value.box3OverigeBezittingen
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        this.updateHeeftOWR();
    }

    protected readonly OverigeBezittingSoort = OverigeBezittingSoort;

    formatSoort(soort: string | undefined): string {
        if (!soort) return '';
        return soort.charAt(0).toUpperCase() + soort.slice(1).toLowerCase().replace(/_/g, ' ');
    }

    getOWRDialogTitel(i: number): string {
        const omschrijving = this.box3OverigeBezittingen.controls[i]?.get('omschrijving')?.value;

        if (!omschrijving) {
            return 'Werkelijk rendement overig bezit';
        }

        return `Werkelijk rendement: ${omschrijving}`;
    }

    updateHeeftOWR(): void {
        this.heeftOWR = this.box3OverigeBezittingen.controls.map((item) => {
            const velden = ['waardeEindJaar', 'directRendement', 'valutaResultaat', 'toenames', 'afnames'];
            return velden.some(veld => item?.get(veld)?.value);
        });
    }

    getBerekendeWerkelijkRendement(i: number): number | null {
        const control = this.box3OverigeBezittingen.at(i);
        const soort = control?.get('soort')?.value;
        const bedrag = Number(control?.get('bedrag')?.value) || 0;
        const directRendement = Number(control?.get('directRendement')?.value) || 0;
        const toenames = Number(control?.get('toenames')?.value) || 0;
        const afnames = Number(control?.get('afnames')?.value) || 0;
        const waardeEindJaar = Number(control?.get('waardeEindJaar')?.value) || 0;

        // Return null als alle waarden leeg zijn
        if (!control?.get('directRendement')?.value && !control?.get('valutaResultaat')?.value &&
            !control?.get('toenames')?.value && !control?.get('waardeEindJaar')?.value &&
            !control?.get('afnames')?.value
        ) {
            return null;
        }

        // Als het contant geld is, alleen directRendement
        if (soort === OverigeBezittingSoort.CONTANT_GELD) {
            return directRendement || null;
        }

        // Normale berekening voor andere soorten
        return directRendement + waardeEindJaar - bedrag + afnames - toenames;
    }
}
